import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ImplementerNavigatorPage } from './implementer-navigator';
import { ImplementerNavigatorComponent } from '../implementer-navigator-component/implementer-navigator-component';
import { ImplementerNavigatorCalendarComponent } from '../implementer-navigator-calendar-component/implementer-navigator-calendar-component';
import { CalendarModule } from 'angular-calendar';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    ImplementerNavigatorPage,
    ImplementerNavigatorComponent,
    ImplementerNavigatorCalendarComponent
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(ImplementerNavigatorPage),
    CalendarModule,
  ],
})
export class ImplementerNavigatorPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-navigator/implementer-navigator.module.ts